import { call, put, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTinhTrangNoMonActionIds, ITinhTrangNoMonActionTypes } from "../../action-types/tinh-trang-no-mon/ITinhTrangNoMonActions";
import { tinhTrangNoMonApi } from "../../../api/tinh-trang-no-mon/tinhTrangNoMonApi";
import { ITinhTrangNoMonRequest } from "../../../model/request/tinh-trang-no-mon/ITinhTrangNoMonRequest";


export function* tinhTrangNoMonSaga() {
    yield takeLatest(eTinhTrangNoMonActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ITinhTrangNoMonActionTypes): any {
    const request = action.payload as ITinhTrangNoMonRequest;
    const res: IBaseResponse = yield call(tinhTrangNoMonApi.SelectAll, request);
    if (res.is_success) {
        yield put(rootActions.tinhTrangNoMon.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.tinhTrangNoMon.LOAD_ERROR(res.message ?? "Có lỗi"));
    }
}